// @ts-ignore
import { Response } from './Response';

export class IsOrderCancellableResponse extends Response {
  get isOrderCancellable() {
    return this.data.cancellable;
  }
}
